
import { ErrorMessage, Field, Formik } from 'formik';
import React, { useState } from 'react'
import { Tooltip, notification } from 'antd';
import { requestPassword, resetPassword } from '../_redux/authCrud';
import * as Yup from 'yup';
import { TextError } from '../../Common/utils';
import { Input as AntInput } from "antd";
import { CustomInput } from "../../../../utility/CustomInput";
import { MetaTags } from 'react-meta-tags';
import { useHistory } from "react-router-dom";


const NewPassword = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const passwordCriteria =
        "Password must contain 8 characters. uppercase, lowercase, number and symbol.";

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .required("Email is required")
            .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Invalid email address"),
        password: Yup.string()
            .required("Password is required")
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*?&])[A-Za-z\d@#$!%*?&]{8,}$/,
                passwordCriteria
            ),
        confirm_password: Yup.string()
            .required("Password confirmation is required")
            .oneOf([Yup.ref('password'), null], 'Passwords must match'),
        otp: Yup.string()
            .matches(/^[0-9]{6,6}$/, "Please enter valid OTP")
            .required("OTP is required"),
    });

    const handleResendOTP = (email) => {
        requestPassword(email)
            .then((res) => {
                notification.success({ message: res.data.message, duration: 3 });
            })
            .catch((err) => {
                err.response.data.errors.map((error) => notification.error({ message: error, duration: 5 }));
            });
    };

    return (
        <>
            <MetaTags>
                <title>Kommerce Hub | Forget Password</title>
                <meta
                    name="description"
                    content="Kommerce Hub - Empowering Commerce, On a mission to streamline your business operations and help you save your time and costs"
                />
            </MetaTags>
            <div className='new-pass-title'>
                <div className="text-center mb-10 mb-lg-20">
                    <h3 className="font-size-h1">Reset Password</h3>
                </div>
                <Formik
                    initialValues={{ email: "", password: "", otp: "", confirm_password: "" }}
                    validationSchema={validationSchema}
                    onSubmit={(values, { setStatus, setSubmitting }) => {
                        setLoading(true);
                        resetPassword(values.otp, values.email, values.password)
                            .then((res) => {
                                setSubmitting(false);
                                setLoading(false);
                                notification.success({ message: res.data.message, duration: 3 });
                                history.push("/auth/login")

                            })
                            .catch((err) => {
                                setSubmitting(false);
                                setLoading(false);
                                err.response.data.errors.map((error) => notification.error({ message: error, duration: 5 }));
                            });
                    }}
                >
                    {({ values, setFieldValue, handleSubmit, isSubmitting }) => (
                        <form onSubmit={handleSubmit} className="form">
                            <div className="form-group">
                                <Field name="otp"
                                    component={CustomInput}
                                    placeholder="Enter OTP"
                                    className="login-input-fields"
                                >
                                </Field>
                            </div>
                            <div className="form-group">
                                <Field name="email"
                                    component={CustomInput}
                                    placeholder="Enter Email"
                                    className="login-input-fields"
                                >
                                </Field>
                            </div>
                            <div className="form-group">
                                <Tooltip
                                    title={<p className='password-tooltip'>{passwordCriteria}</p>}
                                    color={"#F0F0F0"}
                                    overlayStyle={{ maxWidth: "350px" }}
                                    placement="topLeft"
                                >
                                    <Field
                                        autoFill="off"
                                        type="password"
                                        name="password"
                                        className="login-input-fields"
                                        value={values.password}
                                        as={AntInput.Password}
                                        placeholder="Password"
                                        onChange={(e) => {
                                            setFieldValue("password", e.target.value);
                                        }}
                                    />

                                </Tooltip>
                                <div>
                                    <ErrorMessage
                                        name={"password"}
                                        component={TextError}
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <Field
                                    autoFill="off"
                                    type="password"
                                    name="confirm_password"
                                    className="login-input-fields"
                                    value={values.confirm_password}
                                    as={AntInput.Password}
                                    placeholder="Confirm Password"
                                    onChange={(e) => {
                                        setFieldValue("confirm_password", e.target.value);
                                    }}
                                />
                                <div>
                                    <ErrorMessage
                                        name={"confirm_password"}
                                        component={TextError}
                                    />
                                </div>
                            </div>
                            <div className="form-group d-flex flex-wrap flex-center">
                                <button id="kt_login_resend_otp" type="button" className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4" onClick={() => handleResendOTP(values.email)} disabled={isSubmitting}>
                                    Resend OTP
                                </button>
                                <button id="kt_login_forgot_submit" type="submit" className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4" disabled={isSubmitting}>
                                    <span>Submit</span>
                                    {loading && <span className="ml-3 spinner spinner-white"></span>}
                                </button>
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        </>
    )
}

export default NewPassword
